import {useAuth} from "../api/AuthContext";
import {Navigate, Outlet} from "react-router-dom";

export default function AdminPanel() {
return(
    <>Type shit</>
)
};
